/* istanbul ignore file */

export const katexStyles = {
  '@font-face': [{
    fontFamily: "'KaTeX_AMS'",
    src: "url(fonts/KaTeX_AMS-Regular.woff2) format('woff2'), url(fonts/KaTeX_AMS-Regular.woff) format('woff'), url(fonts/KaTeX_AMS-Regular.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_Caligraphic'",
    src: "url(fonts/KaTeX_Caligraphic-Bold.woff2) format('woff2'), url(fonts/KaTeX_Caligraphic-Bold.woff) format('woff'), url(fonts/KaTeX_Caligraphic-Bold.ttf) format('truetype')",
    fontWeight: 'bold',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_Caligraphic'",
    src: "url(fonts/KaTeX_Caligraphic-Regular.woff2) format('woff2'), url(fonts/KaTeX_Caligraphic-Regular.woff) format('woff'), url(fonts/KaTeX_Caligraphic-Regular.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_Fraktur'",
    src: "url(fonts/KaTeX_Fraktur-Bold.woff2) format('woff2'), url(fonts/KaTeX_Fraktur-Bold.woff) format('woff'), url(fonts/KaTeX_Fraktur-Bold.ttf) format('truetype')",
    fontWeight: 'bold',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_Fraktur'",
    src: "url(fonts/KaTeX_Fraktur-Regular.woff2) format('woff2'), url(fonts/KaTeX_Fraktur-Regular.woff) format('woff'), url(fonts/KaTeX_Fraktur-Regular.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_Main'",
    src: "url(fonts/KaTeX_Main-Bold.woff2) format('woff2'), url(fonts/KaTeX_Main-Bold.woff) format('woff'), url(fonts/KaTeX_Main-Bold.ttf) format('truetype')",
    fontWeight: 'bold',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_Main'",
    src: "url(fonts/KaTeX_Main-BoldItalic.woff2) format('woff2'), url(fonts/KaTeX_Main-BoldItalic.woff) format('woff'), url(fonts/KaTeX_Main-BoldItalic.ttf) format('truetype')",
    fontWeight: 'bold',
    fontStyle: 'italic'
  }, {
    fontFamily: "'KaTeX_Main'",
    src: "url(fonts/KaTeX_Main-Italic.woff2) format('woff2'), url(fonts/KaTeX_Main-Italic.woff) format('woff'), url(fonts/KaTeX_Main-Italic.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'italic'
  }, {
    fontFamily: "'KaTeX_Main'",
    src: "url(fonts/KaTeX_Main-Regular.woff2) format('woff2'), url(fonts/KaTeX_Main-Regular.woff) format('woff'), url(fonts/KaTeX_Main-Regular.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_Math'",
    src: "url(fonts/KaTeX_Math-BoldItalic.woff2) format('woff2'), url(fonts/KaTeX_Math-BoldItalic.woff) format('woff'), url(fonts/KaTeX_Math-BoldItalic.ttf) format('truetype')",
    fontWeight: 'bold',
    fontStyle: 'italic'
  }, {
    fontFamily: "'KaTeX_Math'",
    src: "url(fonts/KaTeX_Math-Italic.woff2) format('woff2'), url(fonts/KaTeX_Math-Italic.woff) format('woff'), url(fonts/KaTeX_Math-Italic.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'italic'
  }, {
    fontFamily: "'KaTeX_SansSerif'",
    src: "url(fonts/KaTeX_SansSerif-Bold.woff2) format('woff2'), url(fonts/KaTeX_SansSerif-Bold.woff) format('woff'), url(fonts/KaTeX_SansSerif-Bold.ttf) format('truetype')",
    fontWeight: 'bold',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_SansSerif'",
    src: "url(fonts/KaTeX_SansSerif-Italic.woff2) format('woff2'), url(fonts/KaTeX_SansSerif-Italic.woff) format('woff'), url(fonts/KaTeX_SansSerif-Italic.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'italic'
  }, {
    fontFamily: "'KaTeX_SansSerif'",
    src: "url(fonts/KaTeX_SansSerif-Regular.woff2) format('woff2'), url(fonts/KaTeX_SansSerif-Regular.woff) format('woff'), url(fonts/KaTeX_SansSerif-Regular.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_Script'",
    src: "url(fonts/KaTeX_Script-Regular.woff2) format('woff2'), url(fonts/KaTeX_Script-Regular.woff) format('woff'), url(fonts/KaTeX_Script-Regular.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_Size1'",
    src: "url(fonts/KaTeX_Size1-Regular.woff2) format('woff2'), url(fonts/KaTeX_Size1-Regular.woff) format('woff'), url(fonts/KaTeX_Size1-Regular.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_Size2'",
    src: "url(fonts/KaTeX_Size2-Regular.woff2) format('woff2'), url(fonts/KaTeX_Size2-Regular.woff) format('woff'), url(fonts/KaTeX_Size2-Regular.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_Size3'",
    src: "url(fonts/KaTeX_Size3-Regular.woff2) format('woff2'), url(fonts/KaTeX_Size3-Regular.woff) format('woff'), url(fonts/KaTeX_Size3-Regular.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_Size4'",
    src: "url(fonts/KaTeX_Size4-Regular.woff2) format('woff2'), url(fonts/KaTeX_Size4-Regular.woff) format('woff'), url(fonts/KaTeX_Size4-Regular.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'normal'
  }, {
    fontFamily: "'KaTeX_Typewriter'",
    src: "url(fonts/KaTeX_Typewriter-Regular.woff2) format('woff2'), url(fonts/KaTeX_Typewriter-Regular.woff) format('woff'), url(fonts/KaTeX_Typewriter-Regular.ttf) format('truetype')",
    fontWeight: 'normal',
    fontStyle: 'normal'
  }],
  '.katex': {
    font: 'normal 1.21em KaTeX_Main, Times New Roman, serif',
    lineHeight: 1.2,
    textIndent: '0',
    textRendering: 'auto'
  },
  '.katex *': {
    msHighContrastAdjust: 'none !important',
    borderColor: 'currentColor'
  },
  '.katex .katex-version::after': {
    content: '"0.16.10"'
  },
  '.katex .katex-mathml': {
    position: 'absolute',
    clip: 'rect(1px, 1px, 1px, 1px)',
    padding: '0',
    border: '0',
    height: '1px',
    width: '1px',
    overflow: 'hidden'
  },
  '.katex .katex-html': {},
  '.katex .katex-html > .newline': {
    display: 'block'
  },
  '.katex .base': {
    position: 'relative',
    display: 'inline-block',
    whiteSpace: 'nowrap',
    width: ['-webkit-min-content', '-moz-min-content', 'min-content']
  },
  '.katex .strut': {
    display: 'inline-block'
  },
  '.katex .textbf': {
    fontWeight: 'bold'
  },
  '.katex .textit': {
    fontStyle: 'italic'
  },
  '.katex .textrm': {
    fontFamily: 'KaTeX_Main'
  },
  '.katex .textsf': {
    fontFamily: 'KaTeX_SansSerif'
  },
  '.katex .texttt': {
    fontFamily: 'KaTeX_Typewriter'
  },
  '.katex .mathnormal': {
    fontFamily: 'KaTeX_Math',
    fontStyle: 'italic'
  },
  '.katex .mathit': {
    fontFamily: 'KaTeX_Main',
    fontStyle: 'italic'
  },
  '.katex .mathrm': {
    fontStyle: 'normal'
  },
  '.katex .mathbf': {
    fontFamily: 'KaTeX_Main',
    fontWeight: 'bold'
  },
  '.katex .boldsymbol': {
    fontFamily: 'KaTeX_Math',
    fontWeight: 'bold',
    fontStyle: 'italic'
  },
  '.katex .amsrm': {
    fontFamily: 'KaTeX_AMS'
  },
  '.katex .mathbb,\n.katex .textbb': {
    fontFamily: 'KaTeX_AMS'
  },
  '.katex .mathcal': {
    fontFamily: 'KaTeX_Caligraphic'
  },
  '.katex .mathfrak,\n.katex .textfrak': {
    fontFamily: 'KaTeX_Fraktur'
  },
  '.katex .mathboldfrak,\n.katex .textboldfrak': {
    fontFamily: 'KaTeX_Fraktur',
    fontWeight: 'bold'
  },
  '.katex .mathtt': {
    fontFamily: 'KaTeX_Typewriter'
  },
  '.katex .mathscr,\n.katex .textscr': {
    fontFamily: 'KaTeX_Script'
  },
  '.katex .mathsf,\n.katex .textsf': {
    fontFamily: 'KaTeX_SansSerif'
  },
  '.katex .mathboldsf,\n.katex .textboldsf': {
    fontFamily: 'KaTeX_SansSerif',
    fontWeight: 'bold'
  },
  '.katex .mathitsf,\n.katex .textitsf': {
    fontFamily: 'KaTeX_SansSerif',
    fontStyle: 'italic'
  },
  '.katex .mainrm': {
    fontFamily: 'KaTeX_Main',
    fontStyle: 'normal'
  },
  '.katex .vlist-t': {
    display: 'inline-table',
    tableLayout: 'fixed',
    borderCollapse: 'collapse'
  },
  '.katex .vlist-r': {
    display: 'table-row'
  },
  '.katex .vlist': {
    display: 'table-cell',
    verticalAlign: 'bottom',
    position: 'relative'
  },
  '.katex .vlist > span': {
    display: 'block',
    height: '0',
    position: 'relative'
  },
  '.katex .vlist > span > span': {
    display: 'inline-block'
  },
  '.katex .vlist > span > .pstrut': {
    overflow: 'hidden',
    width: '0'
  },
  '.katex .vlist-t2': {
    marginRight: '-2px'
  },
  '.katex .vlist-s': {
    display: 'table-cell',
    verticalAlign: 'bottom',
    fontSize: '1px',
    width: '2px',
    minWidth: '2px'
  },
  '.katex .vbox': {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'baseline'
  },
  '.katex .hbox': {
    display: 'inline-flex',
    flexDirection: 'row',
    width: '100%'
  },
  '.katex .thinbox': {
    display: 'inline-flex',
    flexDirection: 'row',
    width: '0',
    maxWidth: '0'
  },
  '.katex .msupsub': {
    textAlign: 'left'
  },
  '.katex .mfrac > span > span': {
    textAlign: 'center'
  },
  '.katex .mfrac .frac-line': {
    display: 'inline-block',
    width: '100%',
    borderBottomStyle: 'solid'
  },
  '.katex .mfrac .frac-line,\n.katex .overline .overline-line,\n.katex .underline .underline-line,\n.katex .hline,\n.katex .hdashline,\n.katex .rule': {
    minHeight: '1px'
  },
  '.katex .mspace': {
    display: 'inline-block'
  },
  '.katex .llap,\n.katex .rlap,\n.katex .clap': {
    width: '0',
    position: 'relative'
  },
  '.katex .llap > .inner,\n.katex .rlap > .inner,\n.katex .clap > .inner': {
    position: 'absolute'
  },
  '.katex .llap > .fix,\n.katex .rlap > .fix,\n.katex .clap > .fix': {
    display: 'inline-block'
  },
  '.katex .llap > .inner': {
    right: '0'
  },
  '.katex .rlap > .inner,\n.katex .clap > .inner': {
    left: '0'
  },
  '.katex .clap > .inner > span': {
    marginLeft: '-50%',
    marginRight: '50%'
  },
  '.katex .rule': {
    display: 'inline-block',
    border: 'solid 0',
    position: 'relative'
  },
  '.katex .overline .overline-line,\n.katex .underline .underline-line,\n.katex .hline': {
    display: 'inline-block',
    width: '100%',
    borderBottomStyle: 'solid'
  },
  '.katex .hdashline': {
    display: 'inline-block',
    width: '100%',
    borderBottomStyle: 'dashed'
  },
  '.katex .sqrt > .root': {
    marginLeft: '0.27777778em',
    marginRight: '-0.55555556em'
  },
  '.katex .sizing.reset-size1.size1,\n.katex .fontsize-ensurer.reset-size1.size1': {
    fontSize: '1em'
  },
  '.katex .sizing.reset-size1.size2,\n.katex .fontsize-ensurer.reset-size1.size2': {
    fontSize: '1.2em'
  },
  '.katex .sizing.reset-size1.size3,\n.katex .fontsize-ensurer.reset-size1.size3': {
    fontSize: '1.4em'
  },
  '.katex .sizing.reset-size1.size4,\n.katex .fontsize-ensurer.reset-size1.size4': {
    fontSize: '1.6em'
  },
  '.katex .sizing.reset-size1.size5,\n.katex .fontsize-ensurer.reset-size1.size5': {
    fontSize: '1.8em'
  },
  '.katex .sizing.reset-size1.size6,\n.katex .fontsize-ensurer.reset-size1.size6': {
    fontSize: '2em'
  },
  '.katex .sizing.reset-size1.size7,\n.katex .fontsize-ensurer.reset-size1.size7': {
    fontSize: '2.4em'
  },
  '.katex .sizing.reset-size1.size8,\n.katex .fontsize-ensurer.reset-size1.size8': {
    fontSize: '2.88em'
  },
  '.katex .sizing.reset-size1.size9,\n.katex .fontsize-ensurer.reset-size1.size9': {
    fontSize: '3.456em'
  },
  '.katex .sizing.reset-size1.size10,\n.katex .fontsize-ensurer.reset-size1.size10': {
    fontSize: '4.148em'
  },
  '.katex .sizing.reset-size1.size11,\n.katex .fontsize-ensurer.reset-size1.size11': {
    fontSize: '4.976em'
  },
  '.katex .sizing.reset-size2.size1,\n.katex .fontsize-ensurer.reset-size2.size1': {
    fontSize: '0.83333333em'
  },
  '.katex .sizing.reset-size2.size2,\n.katex .fontsize-ensurer.reset-size2.size2': {
    fontSize: '1em'
  },
  '.katex .sizing.reset-size2.size3,\n.katex .fontsize-ensurer.reset-size2.size3': {
    fontSize: '1.16666667em'
  },
  '.katex .sizing.reset-size2.size4,\n.katex .fontsize-ensurer.reset-size2.size4': {
    fontSize: '1.33333333em'
  },
  '.katex .sizing.reset-size2.size5,\n.katex .fontsize-ensurer.reset-size2.size5': {
    fontSize: '1.5em'
  },
  '.katex .sizing.reset-size2.size6,\n.katex .fontsize-ensurer.reset-size2.size6': {
    fontSize: '1.66666667em'
  },
  '.katex .sizing.reset-size2.size7,\n.katex .fontsize-ensurer.reset-size2.size7': {
    fontSize: '2em'
  },
  '.katex .sizing.reset-size2.size8,\n.katex .fontsize-ensurer.reset-size2.size8': {
    fontSize: '2.4em'
  },
  '.katex .sizing.reset-size2.size9,\n.katex .fontsize-ensurer.reset-size2.size9': {
    fontSize: '2.88em'
  },
  '.katex .sizing.reset-size2.size10,\n.katex .fontsize-ensurer.reset-size2.size10': {
    fontSize: '3.45666667em'
  },
  '.katex .sizing.reset-size2.size11,\n.katex .fontsize-ensurer.reset-size2.size11': {
    fontSize: '4.14666667em'
  },
  '.katex .sizing.reset-size3.size1,\n.katex .fontsize-ensurer.reset-size3.size1': {
    fontSize: '0.71428571em'
  },
  '.katex .sizing.reset-size3.size2,\n.katex .fontsize-ensurer.reset-size3.size2': {
    fontSize: '0.85714286em'
  },
  '.katex .sizing.reset-size3.size3,\n.katex .fontsize-ensurer.reset-size3.size3': {
    fontSize: '1em'
  },
  '.katex .sizing.reset-size3.size4,\n.katex .fontsize-ensurer.reset-size3.size4': {
    fontSize: '1.14285714em'
  },
  '.katex .sizing.reset-size3.size5,\n.katex .fontsize-ensurer.reset-size3.size5': {
    fontSize: '1.28571429em'
  },
  '.katex .sizing.reset-size3.size6,\n.katex .fontsize-ensurer.reset-size3.size6': {
    fontSize: '1.42857143em'
  },
  '.katex .sizing.reset-size3.size7,\n.katex .fontsize-ensurer.reset-size3.size7': {
    fontSize: '1.71428571em'
  },
  '.katex .sizing.reset-size3.size8,\n.katex .fontsize-ensurer.reset-size3.size8': {
    fontSize: '2.05714286em'
  },
  '.katex .sizing.reset-size3.size9,\n.katex .fontsize-ensurer.reset-size3.size9': {
    fontSize: '2.46857143em'
  },
  '.katex .sizing.reset-size3.size10,\n.katex .fontsize-ensurer.reset-size3.size10': {
    fontSize: '2.96285714em'
  },
  '.katex .sizing.reset-size3.size11,\n.katex .fontsize-ensurer.reset-size3.size11': {
    fontSize: '3.55428571em'
  },
  '.katex .sizing.reset-size4.size1,\n.katex .fontsize-ensurer.reset-size4.size1': {
    fontSize: '0.625em'
  },
  '.katex .sizing.reset-size4.size2,\n.katex .fontsize-ensurer.reset-size4.size2': {
    fontSize: '0.75em'
  },
  '.katex .sizing.reset-size4.size3,\n.katex .fontsize-ensurer.reset-size4.size3': {
    fontSize: '0.875em'
  },
  '.katex .sizing.reset-size4.size4,\n.katex .fontsize-ensurer.reset-size4.size4': {
    fontSize: '1em'
  },
  '.katex .sizing.reset-size4.size5,\n.katex .fontsize-ensurer.reset-size4.size5': {
    fontSize: '1.125em'
  },
  '.katex .sizing.reset-size4.size6,\n.katex .fontsize-ensurer.reset-size4.size6': {
    fontSize: '1.25em'
  },
  '.katex .sizing.reset-size4.size7,\n.katex .fontsize-ensurer.reset-size4.size7': {
    fontSize: '1.5em'
  },
  '.katex .sizing.reset-size4.size8,\n.katex .fontsize-ensurer.reset-size4.size8': {
    fontSize: '1.8em'
  },
  '.katex .sizing.reset-size4.size9,\n.katex .fontsize-ensurer.reset-size4.size9': {
    fontSize: '2.16em'
  },
  '.katex .sizing.reset-size4.size10,\n.katex .fontsize-ensurer.reset-size4.size10': {
    fontSize: '2.5925em'
  },
  '.katex .sizing.reset-size4.size11,\n.katex .fontsize-ensurer.reset-size4.size11': {
    fontSize: '3.11em'
  },
  '.katex .sizing.reset-size5.size1,\n.katex .fontsize-ensurer.reset-size5.size1': {
    fontSize: '0.55555556em'
  },
  '.katex .sizing.reset-size5.size2,\n.katex .fontsize-ensurer.reset-size5.size2': {
    fontSize: '0.66666667em'
  },
  '.katex .sizing.reset-size5.size3,\n.katex .fontsize-ensurer.reset-size5.size3': {
    fontSize: '0.77777778em'
  },
  '.katex .sizing.reset-size5.size4,\n.katex .fontsize-ensurer.reset-size5.size4': {
    fontSize: '0.88888889em'
  },
  '.katex .sizing.reset-size5.size5,\n.katex .fontsize-ensurer.reset-size5.size5': {
    fontSize: '1em'
  },
  '.katex .sizing.reset-size5.size6,\n.katex .fontsize-ensurer.reset-size5.size6': {
    fontSize: '1.11111111em'
  },
  '.katex .sizing.reset-size5.size7,\n.katex .fontsize-ensurer.reset-size5.size7': {
    fontSize: '1.33333333em'
  },
  '.katex .sizing.reset-size5.size8,\n.katex .fontsize-ensurer.reset-size5.size8': {
    fontSize: '1.6em'
  },
  '.katex .sizing.reset-size5.size9,\n.katex .fontsize-ensurer.reset-size5.size9': {
    fontSize: '1.92em'
  },
  '.katex .sizing.reset-size5.size10,\n.katex .fontsize-ensurer.reset-size5.size10': {
    fontSize: '2.30444444em'
  },
  '.katex .sizing.reset-size5.size11,\n.katex .fontsize-ensurer.reset-size5.size11': {
    fontSize: '2.76444444em'
  },
  '.katex .sizing.reset-size6.size1,\n.katex .fontsize-ensurer.reset-size6.size1': {
    fontSize: '0.5em'
  },
  '.katex .sizing.reset-size6.size2,\n.katex .fontsize-ensurer.reset-size6.size2': {
    fontSize: '0.6em'
  },
  '.katex .sizing.reset-size6.size3,\n.katex .fontsize-ensurer.reset-size6.size3': {
    fontSize: '0.7em'
  },
  '.katex .sizing.reset-size6.size4,\n.katex .fontsize-ensurer.reset-size6.size4': {
    fontSize: '0.8em'
  },
  '.katex .sizing.reset-size6.size5,\n.katex .fontsize-ensurer.reset-size6.size5': {
    fontSize: '0.9em'
  },
  '.katex .sizing.reset-size6.size6,\n.katex .fontsize-ensurer.reset-size6.size6': {
    fontSize: '1em'
  },
  '.katex .sizing.reset-size6.size7,\n.katex .fontsize-ensurer.reset-size6.size7': {
    fontSize: '1.2em'
  },
  '.katex .sizing.reset-size6.size8,\n.katex .fontsize-ensurer.reset-size6.size8': {
    fontSize: '1.44em'
  },
  '.katex .sizing.reset-size6.size9,\n.katex .fontsize-ensurer.reset-size6.size9': {
    fontSize: '1.728em'
  },
  '.katex .sizing.reset-size6.size10,\n.katex .fontsize-ensurer.reset-size6.size10': {
    fontSize: '2.074em'
  },
  '.katex .sizing.reset-size6.size11,\n.katex .fontsize-ensurer.reset-size6.size11': {
    fontSize: '2.488em'
  },
  '.katex .sizing.reset-size7.size1,\n.katex .fontsize-ensurer.reset-size7.size1': {
    fontSize: '0.41666667em'
  },
  '.katex .sizing.reset-size7.size2,\n.katex .fontsize-ensurer.reset-size7.size2': {
    fontSize: '0.5em'
  },
  '.katex .sizing.reset-size7.size3,\n.katex .fontsize-ensurer.reset-size7.size3': {
    fontSize: '0.58333333em'
  },
  '.katex .sizing.reset-size7.size4,\n.katex .fontsize-ensurer.reset-size7.size4': {
    fontSize: '0.66666667em'
  },
  '.katex .sizing.reset-size7.size5,\n.katex .fontsize-ensurer.reset-size7.size5': {
    fontSize: '0.75em'
  },
  '.katex .sizing.reset-size7.size6,\n.katex .fontsize-ensurer.reset-size7.size6': {
    fontSize: '0.83333333em'
  },
  '.katex .sizing.reset-size7.size7,\n.katex .fontsize-ensurer.reset-size7.size7': {
    fontSize: '1em'
  },
  '.katex .sizing.reset-size7.size8,\n.katex .fontsize-ensurer.reset-size7.size8': {
    fontSize: '1.2em'
  },
  '.katex .sizing.reset-size7.size9,\n.katex .fontsize-ensurer.reset-size7.size9': {
    fontSize: '1.44em'
  },
  '.katex .sizing.reset-size7.size10,\n.katex .fontsize-ensurer.reset-size7.size10': {
    fontSize: '1.72833333em'
  },
  '.katex .sizing.reset-size7.size11,\n.katex .fontsize-ensurer.reset-size7.size11': {
    fontSize: '2.07333333em'
  },
  '.katex .sizing.reset-size8.size1,\n.katex .fontsize-ensurer.reset-size8.size1': {
    fontSize: '0.34722222em'
  },
  '.katex .sizing.reset-size8.size2,\n.katex .fontsize-ensurer.reset-size8.size2': {
    fontSize: '0.41666667em'
  },
  '.katex .sizing.reset-size8.size3,\n.katex .fontsize-ensurer.reset-size8.size3': {
    fontSize: '0.48611111em'
  },
  '.katex .sizing.reset-size8.size4,\n.katex .fontsize-ensurer.reset-size8.size4': {
    fontSize: '0.55555556em'
  },
  '.katex .sizing.reset-size8.size5,\n.katex .fontsize-ensurer.reset-size8.size5': {
    fontSize: '0.625em'
  },
  '.katex .sizing.reset-size8.size6,\n.katex .fontsize-ensurer.reset-size8.size6': {
    fontSize: '0.69444444em'
  },
  '.katex .sizing.reset-size8.size7,\n.katex .fontsize-ensurer.reset-size8.size7': {
    fontSize: '0.83333333em'
  },
  '.katex .sizing.reset-size8.size8,\n.katex .fontsize-ensurer.reset-size8.size8': {
    fontSize: '1em'
  },
  '.katex .sizing.reset-size8.size9,\n.katex .fontsize-ensurer.reset-size8.size9': {
    fontSize: '1.2em'
  },
  '.katex .sizing.reset-size8.size10,\n.katex .fontsize-ensurer.reset-size8.size10': {
    fontSize: '1.44027778em'
  },
  '.katex .sizing.reset-size8.size11,\n.katex .fontsize-ensurer.reset-size8.size11': {
    fontSize: '1.72777778em'
  },
  '.katex .sizing.reset-size9.size1,\n.katex .fontsize-ensurer.reset-size9.size1': {
    fontSize: '0.28935185em'
  },
  '.katex .sizing.reset-size9.size2,\n.katex .fontsize-ensurer.reset-size9.size2': {
    fontSize: '0.34722222em'
  },
  '.katex .sizing.reset-size9.size3,\n.katex .fontsize-ensurer.reset-size9.size3': {
    fontSize: '0.40509259em'
  },
  '.katex .sizing.reset-size9.size4,\n.katex .fontsize-ensurer.reset-size9.size4': {
    fontSize: '0.46296296em'
  },
  '.katex .sizing.reset-size9.size5,\n.katex .fontsize-ensurer.reset-size9.size5': {
    fontSize: '0.52083333em'
  },
  '.katex .sizing.reset-size9.size6,\n.katex .fontsize-ensurer.reset-size9.size6': {
    fontSize: '0.5787037em'
  },
  '.katex .sizing.reset-size9.size7,\n.katex .fontsize-ensurer.reset-size9.size7': {
    fontSize: '0.69444444em'
  },
  '.katex .sizing.reset-size9.size8,\n.katex .fontsize-ensurer.reset-size9.size8': {
    fontSize: '0.83333333em'
  },
  '.katex .sizing.reset-size9.size9,\n.katex .fontsize-ensurer.reset-size9.size9': {
    fontSize: '1em'
  },
  '.katex .sizing.reset-size9.size10,\n.katex .fontsize-ensurer.reset-size9.size10': {
    fontSize: '1.20023148em'
  },
  '.katex .sizing.reset-size9.size11,\n.katex .fontsize-ensurer.reset-size9.size11': {
    fontSize: '1.43981481em'
  },
  '.katex .sizing.reset-size10.size1,\n.katex .fontsize-ensurer.reset-size10.size1': {
    fontSize: '0.24108004em'
  },
  '.katex .sizing.reset-size10.size2,\n.katex .fontsize-ensurer.reset-size10.size2': {
    fontSize: '0.28929605em'
  },
  '.katex .sizing.reset-size10.size3,\n.katex .fontsize-ensurer.reset-size10.size3': {
    fontSize: '0.33751205em'
  },
  '.katex .sizing.reset-size10.size4,\n.katex .fontsize-ensurer.reset-size10.size4': {
    fontSize: '0.38572806em'
  },
  '.katex .sizing.reset-size10.size5,\n.katex .fontsize-ensurer.reset-size10.size5': {
    fontSize: '0.43394407em'
  },
  '.katex .sizing.reset-size10.size6,\n.katex .fontsize-ensurer.reset-size10.size6': {
    fontSize: '0.48216008em'
  },
  '.katex .sizing.reset-size10.size7,\n.katex .fontsize-ensurer.reset-size10.size7': {
    fontSize: '0.57859209em'
  },
  '.katex .sizing.reset-size10.size8,\n.katex .fontsize-ensurer.reset-size10.size8': {
    fontSize: '0.69431051em'
  },
  '.katex .sizing.reset-size10.size9,\n.katex .fontsize-ensurer.reset-size10.size9': {
    fontSize: '0.83317261em'
  },
  '.katex .sizing.reset-size10.size10,\n.katex .fontsize-ensurer.reset-size10.size10': {
    fontSize: '1em'
  },
  '.katex .sizing.reset-size10.size11,\n.katex .fontsize-ensurer.reset-size10.size11': {
    fontSize: '1.19961427em'
  },
  '.katex .sizing.reset-size11.size1,\n.katex .fontsize-ensurer.reset-size11.size1': {
    fontSize: '0.20096463em'
  },
  '.katex .sizing.reset-size11.size2,\n.katex .fontsize-ensurer.reset-size11.size2': {
    fontSize: '0.24115756em'
  },
  '.katex .sizing.reset-size11.size3,\n.katex .fontsize-ensurer.reset-size11.size3': {
    fontSize: '0.28135048em'
  },
  '.katex .sizing.reset-size11.size4,\n.katex .fontsize-ensurer.reset-size11.size4': {
    fontSize: '0.32154341em'
  },
  '.katex .sizing.reset-size11.size5,\n.katex .fontsize-ensurer.reset-size11.size5': {
    fontSize: '0.36173633em'
  },
  '.katex .sizing.reset-size11.size6,\n.katex .fontsize-ensurer.reset-size11.size6': {
    fontSize: '0.40192926em'
  },
  '.katex .sizing.reset-size11.size7,\n.katex .fontsize-ensurer.reset-size11.size7': {
    fontSize: '0.48231511em'
  },
  '.katex .sizing.reset-size11.size8,\n.katex .fontsize-ensurer.reset-size11.size8': {
    fontSize: '0.57877814em'
  },
  '.katex .sizing.reset-size11.size9,\n.katex .fontsize-ensurer.reset-size11.size9': {
    fontSize: '0.69453376em'
  },
  '.katex .sizing.reset-size11.size10,\n.katex .fontsize-ensurer.reset-size11.size10': {
    fontSize: '0.83360129em'
  },
  '.katex .sizing.reset-size11.size11,\n.katex .fontsize-ensurer.reset-size11.size11': {
    fontSize: '1em'
  },
  '.katex .delimsizing.size1': {
    fontFamily: 'KaTeX_Size1'
  },
  '.katex .delimsizing.size2': {
    fontFamily: 'KaTeX_Size2'
  },
  '.katex .delimsizing.size3': {
    fontFamily: 'KaTeX_Size3'
  },
  '.katex .delimsizing.size4': {
    fontFamily: 'KaTeX_Size4'
  },
  '.katex .delimsizing.mult .delim-size1 > span': {
    fontFamily: 'KaTeX_Size1'
  },
  '.katex .delimsizing.mult .delim-size4 > span': {
    fontFamily: 'KaTeX_Size4'
  },
  '.katex .nulldelimiter': {
    display: 'inline-block',
    width: '0.12em'
  },
  '.katex .delimcenter': {
    position: 'relative'
  },
  '.katex .op-symbol': {
    position: 'relative'
  },
  '.katex .op-symbol.small-op': {
    fontFamily: 'KaTeX_Size1'
  },
  '.katex .op-symbol.large-op': {
    fontFamily: 'KaTeX_Size2'
  },
  '.katex .op-limits > .vlist-t': {
    textAlign: 'center'
  },
  '.katex .accent > .vlist-t': {
    textAlign: 'center'
  },
  '.katex .accent .accent-body': {
    position: 'relative'
  },
  '.katex .accent .accent-body:not(.accent-full)': {
    width: '0'
  },
  '.katex .overlay': {
    display: 'block'
  },
  '.katex .mtable .vertical-separator': {
    display: 'inline-block',
    minWidth: '1px'
  },
  '.katex .mtable .arraycolsep': {
    display: 'inline-block'
  },
  '.katex .mtable .col-align-c > .vlist-t': {
    textAlign: 'center'
  },
  '.katex .mtable .col-align-l > .vlist-t': {
    textAlign: 'left'
  },
  '.katex .mtable .col-align-r > .vlist-t': {
    textAlign: 'right'
  },
  '.katex .svg-align': {
    textAlign: 'left'
  },
  '.katex svg': {
    display: 'block',
    position: 'absolute',
    width: '100%',
    height: 'inherit',
    fill: 'currentColor',
    stroke: 'currentColor',
    fillRule: 'nonzero',
    fillOpacity: 1,
    strokeWidth: 1,
    strokeLinecap: 'butt',
    strokeLinejoin: 'miter',
    strokeMiterlimit: '4',
    strokeDasharray: 'none',
    strokeDashoffset: 0,
    strokeOpacity: 1
  },
  '.katex svg path': {
    stroke: 'none'
  },
  '.katex img': {
    borderStyle: 'none',
    minWidth: '0',
    minHeight: '0',
    maxWidth: 'none',
    maxHeight: 'none'
  },
  '.katex .stretchy': {
    width: '100%',
    display: 'block',
    position: 'relative',
    overflow: 'hidden'
  },
  '.katex .stretchy::before,\n.katex .stretchy::after': {
    content: '""'
  },
  '.katex .hide-tail': {
    width: '100%',
    position: 'relative',
    overflow: 'hidden'
  },
  '.katex .halfarrow-left': {
    position: 'absolute',
    left: '0',
    width: '50.2%',
    overflow: 'hidden'
  },
  '.katex .halfarrow-right': {
    position: 'absolute',
    right: '0',
    width: '50.2%',
    overflow: 'hidden'
  },
  '.katex .brace-left': {
    position: 'absolute',
    left: '0',
    width: '25.1%',
    overflow: 'hidden'
  },
  '.katex .brace-center': {
    position: 'absolute',
    left: '25%',
    width: '50%',
    overflow: 'hidden'
  },
  '.katex .brace-right': {
    position: 'absolute',
    right: '0',
    width: '25.1%',
    overflow: 'hidden'
  },
  '.katex .x-arrow-pad': {
    padding: '0 0.5em'
  },
  '.katex .cd-arrow-pad': {
    padding: '0 0.55556em 0 0.27778em'
  },
  '.katex .x-arrow,\n.katex .mover,\n.katex .munder': {
    textAlign: 'center'
  },
  '.katex .boxpad': {
    padding: '0 0.3em'
  },
  '.katex .fbox,\n.katex .fcolorbox': {
    boxSizing: 'border-box',
    border: '0.04em solid'
  },
  '.katex .cancel-pad': {
    padding: '0 0.2em'
  },
  '.katex .cancel-lap': {
    marginLeft: '-0.2em',
    marginRight: '-0.2em'
  },
  '.katex .sout': {
    borderBottomStyle: 'solid',
    borderBottomWidth: '0.08em'
  },
  '.katex .angl': {
    boxSizing: 'border-box',
    borderTop: '0.049em solid',
    borderRight: '0.049em solid',
    marginRight: '0.03889em'
  },
  '.katex .anglpad': {
    padding: '0 0.03889em'
  },
  '.katex .eqn-num::before': {
    counterIncrement: 'katexEqnNo',
    content: '"(" counter(katexEqnNo) ")"'
  },
  '.katex .mml-eqn-num::before': {
    counterIncrement: 'mmlEqnNo',
    content: '"(" counter(mmlEqnNo) ")"'
  },
  '.katex .mtr-glue': {
    width: '50%'
  },
  '.katex .cd-vert-arrow': {
    display: 'inline-block',
    position: 'relative'
  },
  '.katex .cd-label-left': {
    display: 'inline-block',
    position: 'absolute',
    right: 'calc(50% + 0.3em)',
    textAlign: 'left'
  },
  '.katex .cd-label-right': {
    display: 'inline-block',
    position: 'absolute',
    left: 'calc(50% + 0.3em)',
    textAlign: 'right'
  },
  '.katex-display': {
    display: 'block',
    margin: '1em 0',
    textAlign: 'center'
  },
  '.katex-display > .katex': {
    display: 'block',
    textAlign: 'center',
    whiteSpace: 'nowrap'
  },
  '.katex-display > .katex > .katex-html': {
    display: 'block',
    position: 'relative'
  },
  '.katex-display > .katex > .katex-html > .tag': {
    position: 'absolute',
    right: '0'
  },
  '.katex-display.leqno > .katex > .katex-html > .tag': {
    left: '0',
    right: 'auto'
  },
  '.katex-display.fleqn > .katex': {
    textAlign: 'left',
    paddingLeft: '2em'
  },
  body: {
    counterReset: 'katexEqnNo mmlEqnNo'
  }
};